import { styled } from '@mui/material/styles';
import { Button, TextField, Divider, Box, Typography, Checkbox, Grid, Link } from '@mui/material';
import { theme } from '../../../theme';

// Custom styled components
export const ImageContainer = styled(Box)({
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  width: '100%',
  height: '100vh',
});

export const FormContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '2vh 2vw',
  height: '100vh',
  lineHeight: '1.8vh',
});

export const Heading = styled(Typography)({
  fontSize: '4vh',
  alignSelf: 'flex-start',
  color: theme.palette.text.primary,
});

export const IconContainer = styled(Box)({
  display: 'flex',
  gap: '3vw',
  justifyContent: 'center',
  marginBottom: '2vh',
});

export const StyledDivider = styled(Divider)({
  width: '100%',
  margin: '2vh 0',
});

export const StyledTextField = styled(TextField)({
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
    transition: 'border-color 0.3s',
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#7F56D9',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#7F56D9',
    },
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#ccc',
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: '#7F56D9',
  },
  width: '100%',
  marginTop: '0.1vh',
  marginBottom: '2.5vh',
  color: '#92929D',
});

export const StyledButton = styled(Button)({
  height: '6vh',
  borderRadius: '8px',
  alignSelf: 'flex-start',
  width: '100%',
  marginTop: '2vh',
  marginBottom: '2vh',
  backgroundColor: '#7F56D9',
});

export const GridContainer = styled(Grid)({
  Width: '45vw',
  
});

export const TermsContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  margin: '2vh 0',
  gap: '1vw',
  width: '45vw',
});

export const TermsText = styled(Typography)({
  fontSize: '1.2vh',
});

export const CheckboxStyled = styled(Checkbox)({
  padding: '0',
  marginRight: '1vw',
});

export const SignInLink = styled(Link)({
  color: '#3f51b5',
});
